const getQuestaoInternaFromApi = pQuestao => {
  if (pQuestao?.is_questao_interna !== undefined && pQuestao?.is_questao_interna !== null) {
    return Boolean(pQuestao.is_questao_interna);
  }

  if (pQuestao?.isQuestaoInterna !== undefined && pQuestao?.isQuestaoInterna !== null) {
    return Boolean(pQuestao.isQuestaoInterna);
  }

  if (pQuestao?.questao_interna !== undefined && pQuestao?.questao_interna !== null) {
    return Boolean(pQuestao.questao_interna);
  }

  if (pQuestao?.interna !== undefined && pQuestao?.interna !== null) {
    return Boolean(pQuestao.interna);
  }

  return false;
};

export default getQuestaoInternaFromApi;
